import React from 'react'
import styled from 'styled-components'

// Text Align Images
import { ReactComponent as AlignCenter } from '@sketch/icons/text-align-center-16'
import { ReactComponent as AlignJustify } from '@sketch/icons/text-align-justify-16'
import { ReactComponent as AlignLeft } from '@sketch/icons/text-align-left-16'
import { ReactComponent as AlignMiddle } from '@sketch/icons/arrows-down-up-to-line-17'
import { ReactComponent as AlignTop } from '@sketch/icons/arrow-up-to-line-17'
import {
  HorizontalTextAlignment,
  VerticalTextAlignment,
} from '../../../../../../inspector'

const ICON_SIZE = '17px'

export const TextAlignImg = styled.svg.attrs({
  role: 'img',
})`
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
  margin-right: 4px;
  opacity: 50%;
`

export const TextAlignContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
`

export const TextAlign = styled.span`
  text-transform: capitalize;
`

export const TextAlignValue = ({
  alignment,
  label,
}: {
  alignment: HorizontalTextAlignment | VerticalTextAlignment
  label: string
}) => {
  const renderImage = () => {
    switch (alignment) {
      case VerticalTextAlignment.Bottom:
        return (
          <TextAlignImg as={AlignTop} style={{ transform: 'rotate(180deg)' }} />
        )
      case VerticalTextAlignment.Top:
        return <TextAlignImg as={AlignTop} />
      case HorizontalTextAlignment.Right:
        return (
          <TextAlignImg as={AlignLeft} style={{ transform: 'scaleX(-1)' }} />
        )
      case HorizontalTextAlignment.Left:
        return <TextAlignImg as={AlignLeft} />
      case VerticalTextAlignment.Middle:
        return <TextAlignImg as={AlignMiddle} />
      case HorizontalTextAlignment.Center:
        return <TextAlignImg as={AlignCenter} />
      case HorizontalTextAlignment.Justified:
        return <TextAlignImg as={AlignJustify} />
      default:
        return null
    }
  }
  return (
    <TextAlignContainer>
      {renderImage()}
      <TextAlign
        aria-label={`${label} ${
          alignment === HorizontalTextAlignment.Justified
            ? 'justify'
            : alignment
        }`}
      >
        {alignment === HorizontalTextAlignment.Justified
          ? 'justify'
          : alignment}
      </TextAlign>
    </TextAlignContainer>
  )
}
